import { ref } from "vue"

/**
 * @description Manage entities related to S3
 */
class S3Gateway {
  /**
   * @description Service base URL (without trailing `/`)
   */
  public static base_url = ref<string>(import.meta.env.VITE_APP_S3_GATEWAY_URL)
  public static preferred_region = ref<string | null>(null)
  
  public static axios: any

  public static init (axiosInstance: any) {
    S3Gateway.axios = axiosInstance 
  }

  public static set_gateway_url(gateway_url: string|null) {
    if(gateway_url === null){
      S3Gateway.base_url.value = import.meta.env.VITE_APP_S3_GATEWAY_URL
    }
    else{
      S3Gateway.base_url.value = gateway_url
    }
  }

  public static set_preferred_region(region: string | null) {
    S3Gateway.preferred_region.value = region
  }

  public static download_object(bucket_name: string, object_name: string, version_id: string | null = null, progress_callback: any = undefined, preferred_fly_region: string|null = null) {
    const config = {
      responseType: 'blob'
    }
    if(progress_callback){
      config['onDownloadProgress'] = progress_callback
    }

    const fly_region = preferred_fly_region ?? S3Gateway.preferred_region.value
    if(fly_region) {
      config['headers'] = {
        'fly-prefer-region': fly_region.toLowerCase()
      }
    }
    let url = `${S3Gateway.base_url.value}/${bucket_name}/${object_name}`
    if(version_id){
      url += `?versionId=${version_id}`
    }
    return S3Gateway.axios.get(url, config)
  } 

  public static upload_object(bucket_name: string, object_name: string, data: File | Blob, progress_callback: any = undefined) {
    const config = {}
    if(progress_callback){
      config['onUploadProgress'] = progress_callback
    }
    
    // Add headers (bearer token added automatically)
    config['headers'] = {
      // The webapp does not calculate content hash
      'x-amz-content-sha256': 'UNSIGNED-PAYLOAD'
    }
    if(S3Gateway.preferred_region.value) {
      config['headers']['fly-prefer-region'] = S3Gateway.preferred_region.value.toLowerCase()
    }
    // Add content type if present
    if(data.type) config['headers']['Content-Type'] = data.type
    

    return S3Gateway.axios.put(`${S3Gateway.base_url.value}/${bucket_name}/${object_name}`, data=data, config)
  } 

}

export default S3Gateway
